import { Store } from '../State';
import { loadPage } from '../CurrentPage/action-creators';
import { currentUrl } from '../Url';
import { initialRenderDone } from '../CurrentPage/is-initial-render';

export * from './action-creators';
export * from './utils';

export type AppShellData<T = {}> = Scope.AppShellDataBase & T;

export function refreshCachedData(store: Store) {
  console.info('Reloading current page since rendered from service worker...');
  return store.dispatch(
      loadPage({
        url: currentUrl(),
        options: { skipReloadOnVersionMismatch: true, includeAppShellData: true },
        replaceStateOnRedirect: true,
      }),
    ).then(() => {
      initialRenderDone();
    });
}
